<!--
Carousel

A very basic set of carousel logic
-->

<template>
	<section class="c-axiell-carousel" v-if="imagesArray.length">
		<h2 class="h-accessibility">Example Carousel</h2>

		<vue-horizontal class="c-axiell-carousel__viewport" ref="carousel" :button="false" @scroll-debounce="onScroll" @prev="onPrev" @next="onNext">
			<div
				class="c-axiell-carousel__item is-active"
				v-for="image in imagesArray"
				:key="image"
				ref="slide"
			>
				<img :src="getImage(image)" />
			</div>
		</vue-horizontal>

		<nav class="c-axiell-carousel__nav" v-if="imagesArray.length > 1">
			<button class="c-axiell-carousel__prev" @click="prev($event)" :class="{'is-inactive': !hasPrev}">
				<span class="h-accessibility">Go Back. </span>
				<span class="c-axiell-carousel__icon icon">
					<arrowLeft />
				</span>
			</button>
			<button class="c-axiell-carousel__next" @click="next($event)" :class="{'is-inactive': !hasNext}">
				<span class="h-accessibility">Next Item</span>
				<span class="c-axiell-carousel__icon icon">
					<arrowRight />
				</span>
			</button>
		</nav>

		<div class="c-axiell-carousel__footer">
			<p v-html="copyrightInfo"></p>
			<button class="o-button o-button--micro" @click="openCarousel($event)">
				<span class="o-button__icon icon i-expand">
					<expand />
				</span>
				<span>
					View full screen
				</span>
			</button>
		</div>

	</section>
</template>

<script>
	import vueHorizontal from "vue-horizontal";

	import arrowLeft from '/web/static/images/svgs/icon-arrow-left.svg?component';
	import arrowRight from '/web/static/images/svgs/icon-arrow-right.svg?component';
	import expand from '/web/static/images/svgs/icon-expand.svg?component';

	import lightbox from "./lightbox-carousel.vue";

	export default {
		name: "carousel",
		data() {
			return {
				slideWidth: 0,
				currentSlide: 0,
				apiUrl: "/api/axiell?",
				imagesArray: [],
				copyrightArray: [],
				lightboxArray: [],
				isMounted: false,
      			hasNext: false,
				hasPrev: false,
				index: 0,
				carouselData: {
					component: lightbox,
					props: {
						items: [],
						index: 0,
						type: 'gallery',
						modalType: "opaque",
					},
				},
			};
		},
		props: {
			images: {
				type: String,
			},
			copyright: {
				type: String,
			},
		},
		components: {
			vueHorizontal,
			arrowLeft,
			arrowRight,
			expand
		},
		computed: {
			copyrightInfo() {
				return this.copyrightArray[this.index];
			}
		},
		created() {
			if (this.$props.images && this.$props.images.length > 2) { //includes empty square brackets
				this.imagesArray = this.$props.images.replace(/[\[\]']+/g,'').split(',');
			}

			if (this.$props.copyright && this.$props.copyright.length > 2) { //includes empty square brackets
				this.copyrightArray = this.$props.copyright.replace(/[\']+/g,'').slice(1,-1).split(',');
			}
		},
		mounted() {
			var self = this;

			console.log(self.imagesArray.length,self.imagesArray )

			self.slideWidth = self.$refs.slide.clientWidth;

			self.imagesArray.forEach((image, index) => {
				const url = self.getImage(image, true);
				self.lightboxArray.push({imageUrl: url, caption: self.copyrightArray[index] })
			});

			console.log(self.lightboxArray);

			this.isMounted = true;
		},
		methods: {
			prev(e) {
				this.$refs.carousel.prev(e)
			},
			next(e) {
				this.$refs.carousel.next(e)
			},
			onScroll({hasPrev, hasNext}) {
				this.hasPrev = hasPrev
				this.hasNext = hasNext
			},
			getImage(id, full = false) {
				const self = this;

				if (id) {
					if(full) {
						return (
							window.location.origin + self.apiUrl +
							`command=getcontent&server=Detail&value=${id}`
						);
					} else {
						return (
							window.location.origin + self.apiUrl +
							`command=getcontent&server=Detail&width=462&height=573&scalemode=fit&imageformat=png&canvascolor=transparent&value=${id}`
						);
					}

				} else {
					return;
				}
			},
			onPrev() {
				this.index = this.index > 0 ? this.index-1 : 0;
			},
			onNext() {
				this.index = this.index < (this.imagesArray.length - 1) ? this.index+1 : (this.imagesArray.length - 1)
			},
			openCarousel(e, index) {
				if (e != null) {
					e.preventDefault();
				}
				this.loading = true;
				this.carouselData.props.items = this.lightboxArray

				this.$store.dispatch("changeModalContent", this.carouselData);
				this.$store.dispatch("openModal");
				this.loading = false;
			},
		},
	};
</script>
